import Checkbox from '../ApplicationForm/Checkbox';
import TextArea from '../ApplicationForm/TextArea';
import Select from '../ApplicationForm/Select';
import Input from '../ApplicationForm/Input';

export const jsonSchema = {
    type: 'object',
    required: ['firstName', 'lastName', 'email', 'secondaryEmail'],
    properties: {
        firstName: {
            type: 'string',
            title: 'First name',
            required: true
        },
        lastName: {
            type: 'string',
            title: 'Last name',
            required: true
        },
        email: {
            type: 'string',
            title: 'Email',
            required: true
        },
        secondaryEmail: {
            type: 'string',
            title: 'University email',
            required: true
        },
        'question-1': {
            type: 'string',
            title: 'University'
        },
        'question-2': {
            type: 'string',
            title: 'Comments'
        }
    }
};

export const widgets = {
    select: Select,
    input: Input,
    textarea: TextArea,
    checkbox: Checkbox
};

export const customUiSchema = {
    firstName: {
        'ui:widget': 'input',
        'ui:placeholder': 'Ada'
    },
    lastName: {
        'ui:widget': 'input',
        'ui:placeholder': 'Lovelace'
    },
    email: {
        format: 'email',
        'ui:widget': 'input',
        'ui:placeholder': 'ada@lovelace.com'
    },
    secondaryEmail: {
        format: 'email',
        'ui:widget': 'input',
        'ui:placeholder': 'ada@unito.it'
    },
    'question-1': {
        'ui:widget': 'input',
        'ui:placeholder': 'University of Turin'
    },
    'question-2': {
        'ui:widget': 'textarea',
        'ui:placeholder': 'I really want to learn coding - please come to my uni!'
    }
};



/** WEBPACK FOOTER **
 ** ./src/MissingCourse/schema.js
 **/